import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { ModuleConfigService } from "./module-config/module-config.service";
import { map } from "rxjs/operators";
import { AuthService } from "./auth/auth.service";
import { ApiModuleSettingConstants } from "../constants/api-constants/api-module-setting.constants";
let SystemModuleSettingsService = class SystemModuleSettingsService {
    httpClient;
    moduleConfigService;
    authService;
    $systemModuleSettingsFetched;
    systemModuleSettingsSubject = new BehaviorSubject(null);
    $systemModuleSettings;
    _configName = "ViewerConfigFile";
    $isAuthenticated;
    constructor(httpClient, moduleConfigService, authService) {
        this.httpClient = httpClient;
        this.moduleConfigService = moduleConfigService;
        this.authService = authService;
        this.$systemModuleSettings = this.systemModuleSettingsSubject.asObservable();
        this.$isAuthenticated = this.authService.$isAuthenticated;
        this.setupSystemModuleSettingsFetched();
    }
    getSystemModuleSettingsRequest() {
        const params = {
            $filter: `Key eq '${this._configName}'`
        };
        return this.httpClient
            .get(`${ApiModuleSettingConstants.URL}/${ApiModuleSettingConstants.FUNCTION_GET_AFLA_PORTAL_SETTINGS}`)
            .pipe(map((moduleSettings) => {
            this.setModuleConfigs(moduleSettings.value);
            this.systemModuleSettingsSubject.next(moduleSettings.value);
            return moduleSettings.value;
        }));
    }
    getSystemModuleSettings() {
        this.getSystemModuleSettingsRequest().subscribe();
    }
    setModuleConfigs(value) {
        value.forEach((systemModuleSetting) => {
            this.moduleConfigService.addModuleConfigName(systemModuleSetting.moduleId, systemModuleSetting.value);
        });
    }
    listenForAuthenticationChanges() {
        this.$isAuthenticated.subscribe((isAuthenticated) => {
            if (isAuthenticated) {
                this.getSystemModuleSettings();
            }
        });
    }
    setupSystemModuleSettingsFetched() {
        this.$systemModuleSettingsFetched = this.$systemModuleSettings.pipe(map((systemModuleSettings) => {
            return systemModuleSettings != null;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: ModuleConfigService },
        { type: AuthService }
    ];
};
SystemModuleSettingsService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SystemModuleSettingsService);
export { SystemModuleSettingsService };
